import { useDepartmentText } from 'model/DepartmentTerminology';
import { Tooltip } from '@mantine/core';
import { IconArrowUpLeft } from '@tabler/icons-react';
import { DepartmentBreadcrumbItem, formatDepartmentPath } from 'components/department/DepartmentBreadcrumb';

export const HIERARCHY_DEPTH_INDENT = 24;

/** Returns the absolute visual depth of an object in its hierarchy. */
export const getDepartmentHierarchyDepth = (breadcrumbs: DepartmentBreadcrumbItem[]) =>
  Math.max(0, breadcrumbs.length - 1);

/** Parent reference shared by object tables, pickers and permission cards. */
export default function DepartmentParentReference({
  breadcrumbs,
  showFullPath = false,
}: {
  breadcrumbs: DepartmentBreadcrumbItem[];
  showFullPath?: boolean;
}) {
  const departmentText = useDepartmentText();
  if (breadcrumbs.length < 2) {
    return null;
  }

  const parentPath = formatDepartmentPath(showFullPath ? breadcrumbs : breadcrumbs.slice(0, -1));

  return (
    <Tooltip label={parentPath} openDelay={200} withinPortal>
      <IconArrowUpLeft
        aria-label={`${departmentText(
          'Cesta k nadradenej položke úrovne:',
          'Cesta k nadradenému stredisku:'
        )} ${parentPath}`}
        size={16}
        stroke={1.8}
      />
    </Tooltip>
  );
}
